export default [
  {
    path: 'agent',
    name: 'agent',
    component: () => import('@/views/admin/agent/agent.vue'),
    meta: { title: '代理管理' },
    redirect: '/admin/agent/cashout',
    children: [
      {
        path: 'cashout',
        name: 'agentCashout',
        component: () => import('@/views/admin/agent/cashout.vue'),
        meta: { title: '提现记录', tabbar: 'agent' }
      },
      {
        path: 'poster',
        name: 'agentPoster',
        component: () => import('@/views/admin/agent/poster.vue'),
        meta: { title: '海报模板', tabbar: 'agent' }
      },
      {
        path: 'user',
        name: 'agentUser',
        component: () => import('@/views/admin/user/user.vue'),
        meta: { title: '代理用户', tabbar: 'agent' }
      }
    ]
  }
]
